document.addEventListener("DOMContentLoaded", () => {

  const dataElement = document.querySelector("#guitar-color-data");

  if (!dataElement) return;

  const colorData = JSON.parse(
    dataElement.textContent
  );


  // Produktseite
  document.querySelectorAll(
    ".product-form__input--color label"
  ).forEach(label => {

    const name = label.textContent.trim();

    const color = colorData[name];

    if (!color) return;


    if (color.color) {
      label.style.setProperty(
        "--option-color",
        color.color
      );
    }


    if (color.image) {
      label.style.setProperty(
        "--option-color-image",
        `url(${color.image})`
      );
    }

  });


  // Produktkarten / Kollektion
  document.querySelectorAll(
    ".product-card-swatch"
  ).forEach(swatch => {

    const name = swatch.querySelector(
      ".visually-hidden"
    )?.textContent.trim();


    if (!name) return;


    const color = colorData[name];


    if (!color) return;


    if (color.color) {
      swatch.style.setProperty(
        "--option-color",
        color.color
      );
    }


    if (color.image) {
      swatch.style.setProperty(
        "--option-color-image",
        `url(${color.image})`
      );
    }

  });

});